
/*========================================================================
 * $Id: applist.js 75805 2013-10-11 08:12:48Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 Mindbreeze.define('api/v2/applist',[
     "api/v2/common",
     "backbone",
     "underscore",
     "service/stub",
     "service/factory",
     "service/messageframe_channel",
     "service/messageframes",
     "utils/url",
     "service/channels",
     "client/localized_model"
   ], function(
     Common,
     Backbone,
     _,
     Stub,
     ServiceFactory,
     MessageFrameChannel,
     MessageFrames,
     URL,
     Channels,
     LocalizedModel
   ) {

  var Applist = {};

  Applist.Model = LocalizedModel.extend({

    localizedProperties: ["title"],

    parse: function (resp, options) {
      resp = _.clone(resp);

      resp.channels = new Channels();
      _.each(resp.sources, function (source) {
        source = _.clone(source);
        source.url = source.searchURL + "api/v2/";
        source.id = source.url;
        source.useFactory = true;
        source.enabled = false;
        delete source.searchURL;

        resp.channels.add(source);
      });

      delete resp.sources;

      return resp;
    }

  });

  Applist.Applists = Backbone.Collection.extend({

    model: Applist.Model,

    comparator: function (applist) {
      if (applist.get("isCustomDataSources")) return 1;
      return 0;
    },

    initialize: function () {
      this.add({
        id: "custom_datasources",
        isCustomDataSources: true,
        title: "custom_datasources",
        channels: new Channels()
      });
    },

    fetch: function (options) {
      if (!options.channels) return;

      var that = this;
      var responseObserver = this._responseObserver = {};
      var messageFrames = new MessageFrames({
          messageFramePath: "messageFrame.html?id=0&origin=" + URL.getOriginFromDataSource(window.location.href),
          getMessageFrameStart: function () {
            return /^messageFrame:0:/;
          }
      });

      options = _.clone(options || {});
      if (options.parse === void 0) options.parse = true

      _.extend(responseObserver, Backbone.Events);
      this._responseObserver.on("response", function (response, channel) {
        response.id = channel.id;
        that.add(response, options);
      });
      this._responseObserver.on("error", function (error) {
      });

      var channels = _.map(options.channels, function (url) {
        return new MessageFrameChannel({
            url: url,
            messageFrames: messageFrames,
            method: "GET"
        })
      });

      var stub = new ApplistServiceStub();
      stub.cast(channels, null, responseObserver);
    }
  });
  
  var ApplistServiceStub = Applist.ApplistServiceStub = Stub.extend({
    path: "13.3" + "-" + "app-list.json"
  });

  var ApplistServiceFactory = Applist.ServiceFactory = function() {}
  
  _.extend(ApplistServiceFactory.prototype, ServiceFactory.prototype, {
    cast: function (channel) {
      new ApplistServiceStub().cast(channel);
    },

    getApplistPath: function () {
      return new ApplistServiceStub().path;
    }

  });

  return Applist;
});
